/* WorkTriggers.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "work_triggers",
    label: "Schedules",
    disabled: false,
    app: "GameConsole",
    section: "GameCenter",
    order: 11, // Depricated -- Newer solution uses order from index.js
    license: ["GLUWARE"],
    accessPerm: ["scheduleAccess"],
    pageTitle: "Gluware Schedules",
    helpLink: "Schedules/Manage-schedules.htm",
    navIcon: "schedules.solution",
    iconName: "branding.workTriggers",
    lmrbNamespaces: [Registrations.WORK_TRIGGER_EXPLORER_ENTITY_LMRB],
    editorNamespaces: [Registrations.WORK_TRIGGER_INSTANCE_EDITOR],
    workTriggerExplorer: {
        viewNamespaces: [Registrations.WORK_TRIGGER_EXPLORER_VIEW_GRID],
        actionNamespaces: [
            Registrations.WORK_TRIGGER_EXPLORER_ACTION_RUN,
            Registrations.WORK_TRIGGER_EXPLORER_ACTION_PAUSE,
            // Registrations.WORK_TRIGGER_EXPLORER_ACTION_CREATE,
            // Registrations.WORK_TRIGGER_EXPLORER_ACTION_CLONE,
            Registrations.WORK_TRIGGER_EXPLORER_ACTION_DELETE,
        ],
    },
    workTriggerEditor: {
        viewNamespaces: [
            Registrations.WTE_VIEW_DETAILS,
            Registrations.WTE_VIEW_FUTURES,
            Registrations.WTE_VIEW_HISTORY,
            Registrations.WTE_VIEW_ACTIVITY,
            Registrations.WTE_VIEW_WORK,
            Registrations.WTE_VIEW_LOGS,
            Registrations.WTE_VIEW_TARGET_RESULTS,
        ],
        actionNamespaces: [
            Registrations.WTE_ACTION_RUN,
            Registrations.WTE_ACTION_PAUSE,
            Registrations.WTE_ACTION_DELETE,
        ],
    },
};
